module.exports = __webpack_public_path__ + "static/media/mosmetro_sign_bot.b49d7b17.svg";